// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.checkbox-custom-wrapper {
    display: flex;
    align-items: center;
}

.label-checkbox-custom {
    display: block;
    position: relative;
    cursor: pointer;
    width: 1.125rem;
    height: 1.125rem;
    margin-left: 0.5rem;
}

.label-checkbox-custom::before {
    content: "";
    position: absolute;
    top: 50%;
    left: 50%;
    width: 2rem;
    height: 2rem;
    border-radius: 50%;
    background-color: rgba(29, 27, 32, 0.08); /* hover unchecked */
    transform: translate(-50%, -50%) scale(0);
    transition: transform 0.2s ease-in-out, background-color 0.2s ease-in-out;
    pointer-events: none;
    will-change: transform;
    backface-visibility: hidden;
}

/* Hover unchecked */
.checkbox-custom-wrapper:hover .label-checkbox-custom::before {
    transform: translate(-50%, -50%) scale(1);
}

/* Hover checked */
.checkbox-custom-wrapper:hover .label-checkbox-custom:has(input:checked)::before {
    background-color: rgba(103, 80, 164, 0.08);
    transform: translate(-50%, -50%) scale(1);
}

/* Focus unchecked */
.label-checkbox-custom:has(input[type="checkbox"]:focus-visible:not(:checked))::before {
    background-color: rgba(29, 27, 32, 0.12);
    transform: translate(-50%, -50%) scale(1);
}

/* Focus checked */
.label-checkbox-custom:has(input[type="checkbox"]:focus-visible:checked)::before {
    background-color: rgba(103, 80, 164, 0.12);
    transform: translate(-50%, -50%) scale(1);
}

.label-checkbox-custom input[type="checkbox"]:focus-visible + .span-custom-checkbox {
    outline: none;
}

.label-checkbox-custom input[type="checkbox"] {
    appearance: none;
    outline: none;
    position: absolute;
    width: 1.125rem;
    height: 1.125rem;
    opacity: 0;
    margin: 0;
    padding: 0;
    cursor: pointer;
}

.label-checkbox-custom input[type="checkbox"]:disabled {
    cursor: not-allowed;
}

.span-custom-checkbox {
    position: absolute;
    top: 0;
    left: 0;
    width: 1.125rem;
    height: 1.125rem;
    border-radius: 2px;
    border: 2px solid #40484C;
    transition: border-color 0.2s ease-in-out, background-color 0.2s ease-in-out;
}

.label-checkbox-custom input:disabled~.span-custom-checkbox {
    cursor: not-allowed;
    opacity: 0.5;
}

.label-checkbox-custom input:disabled:checked~.span-custom-checkbox {
    opacity: 0.5;
}

.label-checkbox-custom input:disabled~.span-custom-checkbox:hover {
    box-shadow: none !important;
}

.checkbox-custom-wrapper:has(input:disabled):hover .span-custom-checkbox {
    border-color: #D1D5DB !important;
    box-shadow: none !important;
    background-color: #F5F5F5 !important;
}

.checkbox-custom-wrapper:has(input:disabled):hover .label-checkbox-custom::before {
    transform: translate(-50%, -50%) scale(0) !important;
}

.label-checkbox-custom input:checked~.span-custom-checkbox {
    background: #DF6B4E;
    border: 1px solid #DF6B4E;
    border-radius: 2px;
}

.label-checkbox-custom input:checked:hover~.span-custom-checkbox {
    background-color: #DF6B4E;
    border-color: #DF6B4E;
}

.checkbox-custom-wrapper:hover .span-custom-checkbox {
    border-color: #171C1F;
}

.span-custom-checkbox:after {
    content: "";
    position: absolute;
    display: none;
}

.label-checkbox-custom input:checked~.span-custom-checkbox:after {
    display: block;
}

.label-checkbox-custom input:disabled:checked~.span-custom-checkbox:after {
    border-color: #E5E7EB;
}

.label-checkbox-custom .span-custom-checkbox:after {
    left: 5px;
    bottom: 5px;
    width: 6px;
    height: 10px;
    border: solid white;
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
}`, "",{"version":3,"sources":["webpack://./src/components/Inputs/Checkbox/customCheckbox.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,wCAAwC,EAAE,oBAAoB;IAC9D,yCAAyC;IACzC,yEAAyE;IACzE,oBAAoB;IACpB,sBAAsB;IACtB,2BAA2B;AAC/B;;AAEA,oBAAoB;AACpB;IACI,yCAAyC;AAC7C;;AAEA,kBAAkB;AAClB;IACI,0CAA0C;IAC1C,yCAAyC;AAC7C;;AAEA,oBAAoB;AACpB;IACI,wCAAwC;IACxC,yCAAyC;AAC7C;;AAEA,kBAAkB;AAClB;IACI,0CAA0C;IAC1C,yCAAyC;AAC7C;;AAEA;IACI,aAAa;AACjB;;AAEA;IAEI,gBAAgB;IAChB,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,UAAU;IACV,SAAS;IACT,UAAU;IACV,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,yBAAyB;IACzB,4EAA4E;AAChF;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,gCAAgC;IAChC,2BAA2B;IAC3B,oCAAoC;AACxC;;AAEA;IACI,oDAAoD;AACxD;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,SAAS;IACT,WAAW;IACX,UAAU;IACV,YAAY;IACZ,mBAAmB;IACnB,yBAAyB;IACzB,wBAAwB;IACxB,gCAAgC;IAChC,4BAA4B;AAChC","sourcesContent":[".checkbox-custom-wrapper {\n    display: flex;\n    align-items: center;\n}\n\n.label-checkbox-custom {\n    display: block;\n    position: relative;\n    cursor: pointer;\n    width: 1.125rem;\n    height: 1.125rem;\n    margin-left: 0.5rem;\n}\n\n.label-checkbox-custom::before {\n    content: \"\";\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    width: 2rem;\n    height: 2rem;\n    border-radius: 50%;\n    background-color: rgba(29, 27, 32, 0.08); /* hover unchecked */\n    transform: translate(-50%, -50%) scale(0);\n    transition: transform 0.2s ease-in-out, background-color 0.2s ease-in-out;\n    pointer-events: none;\n    will-change: transform;\n    backface-visibility: hidden;\n}\n\n/* Hover unchecked */\n.checkbox-custom-wrapper:hover .label-checkbox-custom::before {\n    transform: translate(-50%, -50%) scale(1);\n}\n\n/* Hover checked */\n.checkbox-custom-wrapper:hover .label-checkbox-custom:has(input:checked)::before {\n    background-color: rgba(103, 80, 164, 0.08);\n    transform: translate(-50%, -50%) scale(1);\n}\n\n/* Focus unchecked */\n.label-checkbox-custom:has(input[type=\"checkbox\"]:focus-visible:not(:checked))::before {\n    background-color: rgba(29, 27, 32, 0.12);\n    transform: translate(-50%, -50%) scale(1);\n}\n\n/* Focus checked */\n.label-checkbox-custom:has(input[type=\"checkbox\"]:focus-visible:checked)::before {\n    background-color: rgba(103, 80, 164, 0.12);\n    transform: translate(-50%, -50%) scale(1);\n}\n\n.label-checkbox-custom input[type=\"checkbox\"]:focus-visible + .span-custom-checkbox {\n    outline: none;\n}\n\n.label-checkbox-custom input[type=\"checkbox\"] {\n    -webkit-appearance: none;\n    appearance: none;\n    outline: none;\n    position: absolute;\n    width: 1.125rem;\n    height: 1.125rem;\n    opacity: 0;\n    margin: 0;\n    padding: 0;\n    cursor: pointer;\n}\n\n.label-checkbox-custom input[type=\"checkbox\"]:disabled {\n    cursor: not-allowed;\n}\n\n.span-custom-checkbox {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 1.125rem;\n    height: 1.125rem;\n    border-radius: 2px;\n    border: 2px solid #40484C;\n    transition: border-color 0.2s ease-in-out, background-color 0.2s ease-in-out;\n}\n\n.label-checkbox-custom input:disabled~.span-custom-checkbox {\n    cursor: not-allowed;\n    opacity: 0.5;\n}\n\n.label-checkbox-custom input:disabled:checked~.span-custom-checkbox {\n    opacity: 0.5;\n}\n\n.label-checkbox-custom input:disabled~.span-custom-checkbox:hover {\n    box-shadow: none !important;\n}\n\n.checkbox-custom-wrapper:has(input:disabled):hover .span-custom-checkbox {\n    border-color: #D1D5DB !important;\n    box-shadow: none !important;\n    background-color: #F5F5F5 !important;\n}\n\n.checkbox-custom-wrapper:has(input:disabled):hover .label-checkbox-custom::before {\n    transform: translate(-50%, -50%) scale(0) !important;\n}\n\n.label-checkbox-custom input:checked~.span-custom-checkbox {\n    background: #DF6B4E;\n    border: 1px solid #DF6B4E;\n    border-radius: 2px;\n}\n\n.label-checkbox-custom input:checked:hover~.span-custom-checkbox {\n    background-color: #DF6B4E;\n    border-color: #DF6B4E;\n}\n\n.checkbox-custom-wrapper:hover .span-custom-checkbox {\n    border-color: #171C1F;\n}\n\n.span-custom-checkbox:after {\n    content: \"\";\n    position: absolute;\n    display: none;\n}\n\n.label-checkbox-custom input:checked~.span-custom-checkbox:after {\n    display: block;\n}\n\n.label-checkbox-custom input:disabled:checked~.span-custom-checkbox:after {\n    border-color: #E5E7EB;\n}\n\n.label-checkbox-custom .span-custom-checkbox:after {\n    left: 5px;\n    bottom: 5px;\n    width: 6px;\n    height: 10px;\n    border: solid white;\n    border-width: 0 2px 2px 0;\n    transform: rotate(45deg);\n    -webkit-transform: rotate(45deg);\n    -ms-transform: rotate(45deg);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
